import React, { FunctionComponent, useState } from "react";
import styles from "./Logo.module.scss";
import LogoProps from "./LogoProps.interface";
import getImageAspectRatio from "app/media/helpers/getImageAspectRatio";
import ImageViewer from "components/ImageViewer/ImageViewer";
import Anchor from "components/Anchor/Anchor";
import combineClasses from "helpers/combine-classes";
import IconViewer from "components/IconViewer/IconViewer";

const Logo: FunctionComponent<LogoProps> = (props) => {
    const imageAspectRatio = getImageAspectRatio(undefined, props.content.image?.umbracoWidth, props.content.image?.umbracoHeight);
    const imageUrl = props.content.image?.umbracoFile.src;

    const [focused, setFocused] = useState(false);
    const overlayFocused = focused ? styles.focused : undefined;

    return (
        <div className={combineClasses([styles.wrapper, overlayFocused])} tabIndex={0} onFocus={() => setFocused(true)} onBlur={() => setFocused(false)} onMouseOver={() => setFocused(true)} onMouseLeave={() => setFocused(false)}>
            {/* Media */}
            <div className={styles.image_wrapper}>
                {props.content.image ? (
                    <ImageViewer className={styles.partnerLogo} extensionType="png" src={imageUrl} alt={props.content.title ? props.content.title : "Partner Logo"} aspectRatioX={imageAspectRatio.aspectRatioX} aspectRatioY={imageAspectRatio.aspectRatioY} {...imageAspectRatio} />
                ) : null}
            </div>

            {/* Content */}
            <div className={combineClasses([styles.overlay, overlayFocused])}>
                {props.content.title ? (
                    <h3 className={combineClasses([styles.title, overlayFocused])}>{props.content.title}</h3>
                ) : null}

                {props.content.description ? (
                    <p className={combineClasses([styles.text, overlayFocused])}>{props.content.description}</p>
                ) : null}

                {props.content.button && props.content.button.length > 0 ? (
                    <Anchor className={combineClasses([styles.button, overlayFocused])} to={props.content.button[0].content.link}>
                        <span className={styles.button_text}>{props.content.button[0].content.label}</span>
                    </Anchor>
                ) : null}
            </div>

            <IconViewer className={combineClasses([styles.arrow_down_right, overlayFocused])} name="arrow-bottom-right" />
        </div>
    );
};

export default Logo;